<form *ngIf="newPersonaForm" [formGroup]="newPersonaForm">
  <div class="grid">
    <div class="col-12 md:col-6">
      <div class="card p-fluid">

        <div class="d-flex mt-2 row">
          <div class="field col-6">
            <app-form-field
              formFieldId="name"
              label="Name"
              [form]="newPersonaForm"
              controlName="name">
              <input pInputText id="name" type="text" formControlName="name" required/>
            </app-form-field>
          </div>
          <div class="field col-6">
            <app-form-field
              formFieldId="deploymentId"
              label="Model"
              [form]="newPersonaForm"
              controlName="deploymentId">
              <p-dropdown id="deploymentId" [options]="models" formControlName="deploymentId" optionLabel="modelFriendlyName" placeholder="Select model" appendTo="body" optionValue="id"></p-dropdown>
            </app-form-field>
          </div>
        </div>

        <div class="field grid mt-2">
          <app-form-field
            formFieldId="prompt"
            label="Prompt"
            [form]="newPersonaForm"
            controlName="prompt">
            <textarea pInputTextarea id="prompt" rows="6" cols="30" formControlName="prompt" required></textarea>
          </app-form-field>
        </div>

        <div class="d-flex mt-2 row">
          <div class="col-6">
            <app-form-field
              formFieldId="maxTokens"
              label="Max response"
              [form]="newPersonaForm"
              controlName="maxTokens"
              [additionalMessage]="'Value between 1 and ' + maxTokens + ''">
              <input pInputText id="maxTokens" type="number" formControlName="maxTokens" required [min]="1" [max]="maxTokens" [placeholder]="'Value between 1 and ' + maxTokens"/>
            </app-form-field>
          </div>
          <div class="col-6">
            <app-form-field
              formFieldId="reasoningEffortLevel"
              label="Reasoning effort"
              [form]="newPersonaForm"
              controlName="reasoningEffortLevel">
              <p-dropdown id="reasoningEffortLevel" [options]="reasoningEffortLevelOptions" formControlName="reasoningEffortLevel"
                          optionLabel="label" optionValue="value" placeholder="Select reasoning effort level" appendTo="body"></p-dropdown>
            </app-form-field>
          </div>
        </div>

        <div class="d-flex mt-2 row">
          <div class="field col-6">
            <app-form-field
              formFieldId="lastMessages"
              label="Last Messages"
              [form]="newPersonaForm"
              controlName="lastMessages"
              additionalMessage="Value between 1 and 100.">
              <input pInputText id="lastMessages" type="number" formControlName="lastMessages" required [min]="1" [max]="100" placeholder="Value between 1 and 100"/>
            </app-form-field>
          </div>
        </div>

        <div class="field grid mt-3">
          <app-labeled-checkbox
            id="default"
            label="Set as default persona"
            controlName="default"
            [form]="newPersonaForm"
            tooltipText="Current default value will be overriden.">
          </app-labeled-checkbox>
        </div>

      </div>
    </div>
  </div>
</form>

<div class="mt-3 d-flex column-gap-3 justify-content-end">
  <button pButton pRipple type="button" class="p-button-secondary h-3rem w-full sm:w-auto" icon="pi pi-times"
          label="Cancel" (click)="onDialogCancel()"></button>
  <button pButton pRipple type="button" class="h-3rem w-full sm:w-auto" icon="pi pi-check"
          label="Confirm" (click)="onSubmit()" [loading]="processing"></button>
</div>
